import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState, useCallback, useContext } from "react";
import { Trash } from "react-feather";
import { UsersData } from "src/ContextAPI";
import Notify from "src/notification/Notify";
import IsMountedRef from "src/utils/IsMountedRef";
import CreateOrder from "./CreateOrder";

const AddOnOtherTest = ({
  patient_id,
  getPatientBillingDetails,
  trace_number,
}) => {
  const [list, setList] = useState({ data: null, ready: false });
  const { users } = useContext(UsersData);
  const mounted = IsMountedRef();

  const getOtherOrderUnpaidList = useCallback(async () => {
    let response = await axios.get("cashier/add-on/othertest-unpaid", {
      params: {
        management_id: users.management_id,
        main_mgmt_id: users.main_mgmt_id,
        department: "Other Test",
      },
    });

    if (mounted.current) {
      setList({ data: response.data, ready: true });
    }
  }, [mounted, users]);

  const handleRemoveOrderTest = async (cpb_id) => {
    var formdata = new FormData();
    formdata.set("cpb_id", cpb_id);

    let response = await axios.post(
      "cashier/other/order/remove-othertest",
      formdata
    );

    const data = response.data;
    if (data.message === "success") {
      Notify.successRequest("Order remove");
      getOtherOrderUnpaidList();
    }
  };

  useEffect(() => {
    getOtherOrderUnpaidList();
  }, [getOtherOrderUnpaidList]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <CreateOrder
          trace_number={trace_number}
          patient_id={patient_id}
          getPatientBillingDetails={() => getPatientBillingDetails()}
          getOtherOrderUnpaidList={() => getOtherOrderUnpaidList()}
        />
      </Grid>
      <Grid item xs={12} sm={8}>
        <Card>
          <CardHeader title="Unpaid Other Test Order" />
          <CardContent>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell> Department </TableCell>
                    <TableCell> Bill Name </TableCell>
                    <TableCell> Bill Amount </TableCell>
                    <TableCell> Action </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {list.ready ? (
                    list.data.length > 0 ? (
                      list.data.map((data, key) => (
                        <TableRow key={key}>
                          <TableCell> {data.bill_department} </TableCell>
                          <TableCell> {data.bill_name} </TableCell>
                          <TableCell align="right">
                            {data.bill_amount}
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              color="secondary"
                              onClick={() => handleRemoveOrderTest(data.cpb_id)}
                            >
                              <Trash />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell align="center" colSpan={4}>
                          <Typography color="secondary">
                            No record found.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={4}>
                        <Typography color="primary">
                          Loading, Please wait...
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default AddOnOtherTest;
